export const TELEGRAM_LINK = 'https://t.me/elephant_money';
export const TWITTER_LINK = 'https://X.com/ElephantStatus';
// export const FACEBOOK_LINK = 'https://www.facebook.com/ryan.jaenicke';
// export const INSTAGRAM_LINK =
// ('https://www.instagram.com/degeneratepassiveincome/');
// export const TIKTOK_LINK = 'https://www.tiktok.com/@degeneratepassiveincome';
